import React from "react";
import { useNavigate } from "react-router-dom";
import "../../css/LandingPage.css";

const LandingPage = () => {
  const navigate = useNavigate();

  return (
    <div
      className="landing-page"
      style={{ backgroundImage: "url('/imagenes/background-home.jpg.png')" }}
    >
      <img
        src="/imagenes/LOGO3.png"
        alt="Logo"
        className="landing-page__logo"
      />
      <h1 className="landing-page__title">
        Vigilancia Epidemiológica de Contactos
      </h1>
      <button
        onClick={() => navigate("/login")}
        className="btn btn-primary landing-page__button"
      >
        Acceder al sistema
      </button>
    </div>
  );
};

export default LandingPage;
